import { useState } from "react";

export default function General() {
  const [notifications, setNotifications] = useState(true);
  const [sound, setSound] = useState(false);
  const [homepage, setHomepage] = useState("dashboard");

  return (
    <div className="p-6">
      <h3 className="text-xl font-semibold text-gray-900 dark:text-white">Paramètres généraux</h3>

      {/* Notifications */}
      <div className="mt-4 flex items-center justify-between">
        <span className="text-gray-700 dark:text-gray-300">Activer les notifications</span>
        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            checked={notifications}
            onChange={() => setNotifications(!notifications)}
            className="sr-only peer"
          />
          <div className="w-11 h-6 bg-gray-300 peer-focus:ring-2 peer-focus:ring-indigo-500 rounded-full peer-checked:bg-indigo-600 peer-checked:after:translate-x-full after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
        </label>
      </div>

      {/* Son */}
      <div className="mt-4 flex items-center justify-between">
        <span className="text-gray-700 dark:text-gray-300">Activer le son</span>
        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            checked={sound}
            onChange={() => setSound(!sound)}
            className="sr-only peer"
          />
          <div className="w-11 h-6 bg-gray-300 peer-focus:ring-2 peer-focus:ring-indigo-500 rounded-full peer-checked:bg-indigo-600 peer-checked:after:translate-x-full after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
        </label>
      </div>

      {/* Page d'accueil */}
      <div className="mt-4">
        <label className="text-gray-700 dark:text-gray-300">Page d'accueil par défaut</label>
        <select
          value={homepage}
          onChange={(e) => setHomepage(e.target.value)}
          className="w-full mt-2 p-2 border rounded-lg bg-white dark:bg-gray-700 dark:text-white"
        >
          <option value="dashboard">📊 Dashboard</option>
          <option value="partenaires">🤝 Partenaires</option>
          <option value="produits">📦 Produits</option>
          <option value="prospects">🔍 Prospection</option>
          <option value="calendrier">📅 Calendrier</option>
        </select>
      </div>

      {/* Affichage des paramètres actuels */}
      <p className="mt-4 text-gray-700 dark:text-gray-300">
        Notifications : <span className="font-semibold">{notifications ? "Activées" : "Désactivées"}</span>
      </p>
      <p className="mt-2 text-gray-700 dark:text-gray-300">
        Son : <span className="font-semibold">{sound ? "Activé" : "Désactivé"}</span>
      </p>
      <p className="mt-2 text-gray-700 dark:text-gray-300">
        Page d'accueil : <span className="font-semibold">{homepage}</span>
      </p>
    </div>
  );
}
